import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { ThinCheckbox } from '../Styles';

const CheckboxTableCell = ({ checked, disabled = true, onChange, sx }) => {
  return (
    <TableCell align='center' sx={sx}>
      <ThinCheckbox checked={checked} disabled={disabled} onChange={onChange} />
    </TableCell>
  );
};

CheckboxTableCell.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
  onChange: PropTypes.func
};

export default CheckboxTableCell;
